import HeroBop from 'shared/lib/assets/img/landing/hero-bop.png';
import LogoChubb from 'shared/lib/assets/img/logo/logo-chubb.svg';
import * as typeformEmbed from '@typeform/embed';

const typeformModal = typeformEmbed.makePopup(
  `https://sureapp.typeform.com/to/MOsleL?id=blue_app&partner=blueApp`,
  {}
);

const handleTypeformClick = () => {
  typeformModal.open();
};

export const bopConfig = {
  hero: {
    heading: 'Big ideas for small businesses',
    subheading:
      'This all-in-one protection policy covers critical items and allows you to focus on the big picture for your small business.',
    cta: 'Get small business insurance',
    ctaLink: handleTypeformClick,
    img: HeroBop,
  },
  underwriter: {
    img: LogoChubb,
    name: 'Chubb',
  },
  coverageDetails: [
    {
      heading: 'General Liability',
      subheading:
        'Protects you, your business, and your employees from claims involving bodily injury or property damage.',
    },
    {
      heading: 'Lost Business Income',
      subheading:
        'Provides coverage for lost income if your business has to close as the result of a covered loss.',
    },
    {
      heading: 'Hired + Non-Owned Auto',
      subheading:
        'Provides liability coverage if you or your employees use personal vehicles for your business on an incidental basis. (This is not commercial auto coverage).',
    },
    {
      heading: 'Employee Liability Coverage',
      subheading:
        'Protects your business in the event of a lawsuit for wrongful termination, harassment, and more.',
    },
    {
      heading: 'Additional Insured',
      subheading:
        'Additional insured status to the listed party, and enables you to save time and money involved in adding specific endorsements when additional insured are required.',
    },
    {
      heading: 'Data Breach: Privacy Liability',
      subheading: 'Protects you in the event of a cyber-attack.',
    },
    {
      heading: 'Business Personal Property',
      subheading:
        'Covers damage and loss of business-owned property, including furniture, equipment, and more.',
    },
    {
      heading: 'Data Breach: Additional Costs',
      subheading:
        'Covers the costs associated with a data breach, such as legal aid, notification costs, and reimbursement of credit monitoring services.',
    },
  ],
  scenarioDetails: {
    heading: 'Why Would You Need Small Business Insurance?',
    scenarios: [
      {
        heading: 'Scenario 1',
        subheading:
          'You’re finally signing the lease for your new office space, but wait - you need proof of insurance!',
      },
      {
        heading: 'Scenario 2',
        subheading:
          'A hurricane leaves your business in bad shape, ruining thousands of dollars’ worth of equipment.',
      },
      {
        heading: 'Scenario 3',
        subheading:
          'An employee gets into a fender bender while making a delivery from your store.',
      },
      {
        heading: 'Scenario 4',
        subheading:
          'Some highly sensitive information about your firm is compromised after a hacker hits your system.',
      },
    ],
  },
  comparison: [
    'Instant quote',
    'Buy and manage your policy in one place',
    'Insurance explained in simple, easy-to-digest way',
    'Mobile',
    'Endorsements',
    'Plan tailored to fit your needs',
  ],
};
